<!--供应商订单详情页面-->
<template>
  <el-dialog :title="pcustomer" :visible.sync="dialogstoreVisible" custom-class="full-dialog" center :append-to-body="true"
             :close-on-click-modal="false">
    <div ref="print1">
      <el-row>
        <div class="search-content">
          <el-row class="toobar" :gutter="5">
            <el-col :span="19">
              <el-select v-model="datetype" placeholder="请选择" style="width: 100px" size="mini">
                <el-option
                  v-for="item in datetypes"
                  :key="item.item"
                  :label="item.name"
                  :value="item.item">
                </el-option>
              </el-select>
              <el-date-picker
                style="width: 290px" size="mini"
                v-model="searchdatevalue" :clearable="false"
                type="daterange" :value-format="'yyyy-MM-dd'"
                align="left" :unlink-panels="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-select v-model="searchstatus" placeholder="请选择状态" style="width:120px;" size="mini">
                <el-option
                  v-for="item in statusdata"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-input auto-complete="off" v-model="searchtext" placeholder="销售或采购单号" style="width:140px;" size="mini"
                        clearable></el-input>
              <el-input auto-complete="off" v-model="tracknum" placeholder="供应商单号" style="width:140px;" size="mini"
                        clearable></el-input>
              <el-input auto-complete="off" v-model="logisticstracknum" placeholder="跟踪号" style="width:140px;" size="mini"
                        clearable></el-input>
              <el-select v-model="cangkucode" filterable style="width: 140px" size="mini">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode">
                </el-option>
              </el-select>
              <el-input placeholder="请品牌" v-model="categoryname" size="mini" style="width:210px;" clearable  @click.native="showCategoryDetailSel" @clear="clearCategory"></el-input>
              <el-input placeholder="请商品" v-model="seedname" clearable @click.native="showGoodDetailSel" size="mini" style="width:210px;" @clear="clearSeedCode"></el-input>
              <el-input-number v-model="Y" placeholder="球镜" style="width:100px;" size="mini" :step="0.25" :precision="2" controls-position="right"></el-input-number>
              <el-input-number v-model="X" placeholder="柱镜" style="width:100px;" size="mini" :step="0.25" :precision="2" controls-position="right"></el-input-number>
            </el-col>
            <el-col :span="5">
              <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
              <br>
            </el-col>
          </el-row>
        </div>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-table :data="tableData"
                      :height="eltableheight"
                      size="mini"
                      stripe
                      border
                      style="width: 100%;">
              <el-table-column
                width="60" fixed
                label="序号"
                align="center"
              >
                <template slot-scope="scope">
                  {{1+scope.$index}}
                </template>
              </el-table-column>
              <el-table-column
                prop="erpserial"
                label="采购单号"
                align="center" fixed
                header-align="center" width="120">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.erpserial }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="hetongserial"
                label="销售单号"
                align="left"
                header-align="center" fixed
                width="140">
                <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.hetongserial}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="seedname" fixed :show-overflow-tooltip="true"
                label="产品名称"
                width="200"
                align="left" fixed
                header-align="center">
                <template slot-scope="scope">
                  {{ scope.row.seedname }}
                </template>
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="产品编码"
                align="left"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <div style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width: 96%;height:24px;"
                       :title="scope.row.seedcode">{{ scope.row.seedcode }}
                  </div>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="leibie" :show-overflow-tooltip="true"-->
                <!--label="类别"-->
                <!--align="left"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="pinpai" :show-overflow-tooltip="true"-->
                <!--label="品牌"-->
                <!--align="left"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
                <!--prop="xilie" :show-overflow-tooltip="true"-->
                <!--label="系列"-->
                <!--align="left"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <el-table-column
                               prop="packagesizeY"
                               label="球镜/规格"
                               align="right"
                               header-align="center"
                               width="105">
                <template slot-scope="scope">
                  {{getPackagesizeY(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column
                               prop="packagesizeX"
                               label="柱镜/色号"
                               align="right"
                               header-align="center"
                               width="105">
                <template slot-scope="scope">
                  {{getPackagesizeX(scope.row.packagesize)}}
                </template>
              </el-table-column>
              <el-table-column
                prop="htqd"
                label="下单时间"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.htqd }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="handleoverdate"
                label="到货时间"
                align="center"
                header-align="center"
                width="140">
                <template slot-scope="scope">
                  <span>
                    {{ scope.row.handleoverdate }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="right"
                header-align="center"
                width="80"
                prop="totalnumber">
                <template slot-scope="scope">
                  {{scope.row.totalnumber|numeric(0)}}
                </template>
              </el-table-column>
              <el-table-column
                label="供应号"
                align="right"
                header-align="center" :show-overflow-tooltip="true"
                width="100"
                prop="tracknum">
              </el-table-column>
              <el-table-column
                label="跟踪号" :show-overflow-tooltip="true"
                align="right"
                header-align="center"
                width="100"
                prop="logisticstracknum">
              </el-table-column>
              <el-table-column
                label="采购备注"
                align="right"
                :show-overflow-tooltip="true"
                header-align="center"
                width="200">
                <template slot-scope="scope">
              {{getLiuYan(scope.row.remark)}}
                </template>
              </el-table-column>
              <el-table-column
                label="操作" fixed="right"
                align="right"
                header-align="center"
                width="80">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="lookbuyorderdetail(scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="foot">
              <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"
                          :showlagersize="true"></Pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <BuyorderDetail ref="BuyorderDetail" @bindGrid="bindGrid"></BuyorderDetail>
      <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
      <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid"></CstagreementEdit>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <JxcgoodscategorySel ref="JxcgoodscategorySel" @afterSelectCode="afterSelectCategoryCode"></JxcgoodscategorySel>
    </div>
  </el-dialog>
</template>
<script>
  import {servicesub, supplierDeptList} from '@/api/set/jiesuan';
  import {ConvertMoney, getRemark} from '@/plugin/ordercommon';
  import {updateDuiZhang} from '@/api/set/csagreement'
  import {independentDept} from '@/api/set/dept';
  import BuyorderDetail from '@/components/testorder/buyagreement/BuyorderDetail'
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import JxcgoodscategorySel from '../set/jxcgoodscategory/JxcgoodscategorySel'

  export default {
    name: '',
    data() {
      return {
        text: {},
        temp: [],
        type: 'sale',
        eltableheight: 300,
        formLabelWidth: '120px',
        seen: false,
        dialogstoreVisible: false,
        showPackageSize: false,
        loading: true,
        priceSub:false,
        showdept:true,
        searchdatevalue: '',
        aging:[],
        agingbm:'',
        htqd:'',
        jhjgrq:'',
        hetongguid:'',
        categorycode:'',
        categoryname:'',
        tableData: [],
        tableDataExcel: [],
        pcustomerserial: '',
        pcustomer: '',
        searchjxs: '',
        searchstatus: '1',
        searchtext: "",//销售或者采购单号查询
        seedname: "",//查询条件显示
        seedcode: "",//查询条件显示
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        Y: undefined,//球镜
        X: undefined,//柱镜
        pagination: {
          currentPage: 1,
          pageSize: 50,
          total: 0
        },
        jxsdata: [],
        statusdata: [{
          value: '',
          text: '全部'
        },
          {
            value: '1',
            text: '已到货'
          },
          {
            value: '-1',
            text: '未到货'
          },
          {
            value: '-2',
            text: '已退货'
          },
        ],
        datetypes: [{
          name: '按到货日期',
          item: 2
        },
          {
            name: '按订单日期',
            item: 3
          },
        ],
        datetype: 2,
        userInfoModel: {},//缓存信息
        jxcstoreData: [],//仓库
        cangkucode: '',//选择后的仓库编码
        logisticstracknum: '',//跟踪单号
        tracknum: '',//供应商单号

      }
    },
    methods: {
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          if (this.userInfoModel.independentserial == "") {//总部登录
            this.jxcstoreData.unshift({
              cangkuname: "全部仓库",
              cangkucode: ''
            })
          }
          this.cangkucode = this.jxcstoreData[0].cangkucode;
        })
      },
      getLiuYan(remark) {
        return getRemark(remark).replace(/<br\/>/g, "；");
      },
      /////////////////////////
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.canshowgoodsel = false
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgooddetailSel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
      },
      //显示商品类别选择页面
      showCategoryDetailSel() {
        if (this.canshowgoodsel) {
          this.$refs.JxcgoodscategorySel.show()
        } else {
          this.canshowgoodsel = true
        }
      },
      //选择商品类别之后执行
      afterSelectCategoryCode(row) {
        this.categorycode =row.categorycode
        this.categoryname = row.categoryname
      },
      getPackagesizeY(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return ps.Y ? ps.Y : ps.M;
      },
      getPackagesizeX(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);

        return ps.X ? ps.X : ps.C;
      },
      //查看订单
      lookdingdan(item) {
        var serial = item["hetongserial"]
        if (!serial) {
          return;
        }

        switch (serial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(serial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(serial);
            break;
          default:
            let row = {
              erpserial: serial
            }
            this.$refs.DataContactEdit.initData(row)
            this.$refs.DataContactEdit.show()
            break;
        }
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, 1)
        this.$refs.BuyorderDetail.show();
      },
      initData(pcustomerserial, pcustomer, defaultOrderDate) {
        this.pcustomerserial = pcustomerserial
        this.pcustomer = pcustomer
        this.canshowgoodsel = true
        // 传参控制默认日期类型：true=按下单日期，false/undefined=按到货日期
        if (defaultOrderDate) {
          this.datetype = 3
          this.searchstatus = '-1' // 未到货
        } else {
          this.datetype = 2
          this.searchstatus = '1' // 已到货
        }
        this.dialogstoreVisible = true
        this.bindGrid();
      },
      getXY() {
        if (this.X||parseFloat(this.X)==0||this.Y||parseFloat(this.Y)==0) {//{"X":"0.00","Y":"-0.50"
          var search="{"
          if(this.X||parseFloat(this.X)==0){
            search+='"X":"'+parseFloat(this.X).toFixed(2)+'",';
          }else {
            search+='"X":"%",';
          }
          if(this.Y||parseFloat(this.Y)==0){
            search+='"Y":"'+parseFloat(this.Y).toFixed(2)+'"';
          }else {
            search+='"Y":"%"';
          }
          return search+"%";
        }
        return '';
      },
      bindGrid() {
        this.tableData = []

        var bDate;
        var eDate;
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        bDate = startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + "-" + startDate.getDate();
        eDate = endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + "-" + endDate.getDate();


        var offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
        var limit = this.pagination.pageSize;

        var categorycodelist = this.categorycode;
        var filltemplates = "";

        supplierDeptList({
          offset: offset,
          limit: limit,
          pcustomerserial: this.pcustomerserial,
          ifsend: this.searchstatus,
          needpackagesize: 1,
          searchtext: this.searchtext,
          seedcode: this.seedcode,
          datetype: this.datetype,
          begindate: bDate,
          enddate: eDate,
          cangkucode: this.cangkucode,
          tracknum: this.tracknum,
          logisticstracknum: this.logisticstracknum,
          categorycodelist: categorycodelist,
          filltemplates: filltemplates,
          pachagesize:this.getXY()
        }).then(request => {
          var th = this.dialogtableHeight(175);
          this.eltableheight = this.eltableheight == th ? (th - 1) : th;
          this.tableData = request.data.obj.rows
          this.pagination.total = request.data.obj.total
        }).catch((error) => {
          console.log(error)
        });
      },
    },
    mounted() {
      var end = new Date();//当天
      var start = new Date(end.getFullYear()-1, end.getMonth(), end.getDate());
      this.searchdatevalue = [start, end];
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.datetype = 2
      this.searchstatus = '1'
      this.cusandptbyind();//仓库的方法
    },
    components: {
      CstagreementEdit,
      BuyorderDetail,
      JxcgooddetailSel,
      BaoSunDetail,
      StorageBadOut,
      JxcgoodscategorySel
    }
  }
</script>

<style>
  .duizhang {
    margin-right: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/OrderSupplySee.vue